/**
 * Production-safe logger utility
 * In production, error logs are suppressed unless explicitly enabled
 * This prevents information disclosure while still allowing debugging when needed
 */

const isDevelopment = process.env.NODE_ENV === 'development';
const enableProductionLogs = process.env.REACT_APP_ENABLE_LOGS === 'true';

const logger = {
  /**
   * Log debug information (only in development)
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.log('[DEBUG]', ...args);
    }
  },

  /**
   * Log informational messages (only in development or if explicitly enabled)
   */
  info: (...args) => {
    if (isDevelopment || enableProductionLogs) {
      console.log('[INFO]', ...args);
    }
  },

  /**
   * Log warnings (only in development or if explicitly enabled)
   */
  warn: (...args) => {
    if (isDevelopment || enableProductionLogs) {
      console.warn('[WARN]', ...args);
    }
  },

  /**
   * Log errors (suppressed in production to prevent info disclosure)
   * Errors should be sent to a monitoring service in production
   */
  error: (...args) => {
    if (isDevelopment || enableProductionLogs) {
      console.error('[ERROR]', ...args);
    }
    // TODO: In production, send to error monitoring service (Sentry, LogRocket, etc.)
  },
};

export default logger;
